module.exports = __webpack_public_path__ + "img/service_backend_4_mob.eaa847d9.jpg";